var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.6,
    height: 16.6,
    viewBox: "0 0 22.6 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242",
    transform: "translate(-1822.7 -938.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M1716,901h20",
    transform: "translate(108 39)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M1716,901h12",
    transform: "translate(112 46)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M1716,901h4",
    transform: "translate(116 53)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeLinecap: "round",
    strokeWidth: 2.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.043df8f552538ad595560a8f799285f3.svg";
export { ForwardRef as ReactComponent };